import React, { useEffect, useState } from "react";
import MainHeader from "../mainHeader/MainHeader";
import { useStoreon } from "storeon/react";
import { useHistory } from "react-router-dom";
import { APPLY_MAIN_HEADER_SETTINGS } from "../../../store/mainHeaderSettings";
import Menu from "../menu/menu";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./Layout.scss";
import routes from "shared/utils/constants/routes";

const Layout = ({ children }) => {
    const { dispatch, mainHeaderSettings } = useStoreon("mainHeaderSettings");
    const history = useHistory();
    const [toggleMenu, setToggleMenu] = useState(false);

    useEffect(() => {
        setMainHeader(history.location.pathname);
        history.listen((data) => {
            setMainHeader(data.pathname);
            setToggleMenu(false);
        });
    }, []);

    const setMainHeader = (pathname) => {
        const settings = {
            showMenu: true,
            back: false,
            goToBack: () => history.goBack(),
            customizeAdd: false,
            viewName: "",
            backArrow: false,
        };

        switch (pathname) {
          case "/live-score-players":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              viewName: "",
            });
            break;
          case "/live-scores":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              viewName: "",
            });
            break;
          case routes.Themes.URLS:
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: false,
              viewName: "Generate live scoring URL",
            });
            break;
          case "/settings-general":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              backArrow: true,
              viewName: "General Settings",
            });
            break;
          case "/settings-cards":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Score Card Settings",
            });
            break;
          case "/settings-tables":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Score Tables Settings",
            });
            break;
          case routes.Themes.LIST:
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Themes Settings",
              goToBack: () => history.goBack(),
            });
            break;
          case routes.Themes.NEW:
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "New theme",
              goToBack: () => history.goBack(),
            });
            break;

          case routes.Themes.EDIT:
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Edit theme",
              goToBack: () => history.goBack(),
            });
            break;
          case "/profile":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Profile Settings",
            });
            break;
          case "/users":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
              showMenu: true,
              backArrow: true,
              viewName: "Users",
            });
            break;
          case "/":
            dispatch(APPLY_MAIN_HEADER_SETTINGS, {
              ...settings,
            });
            break;
          default:
            break;
        }
    };

    return history.location.pathname !== "/users" ? (
        <div className="LayoutContainer">
            <PerfectScrollbar options={{ maxScrollbarLength: 300 }}>
                <div style={{ maxHeight: "100%" }}>
                    <MainHeader
                        {...mainHeaderSettings}
                        toggleMenu={() => setToggleMenu(!toggleMenu)}
                    />
                    <Menu
                        open={toggleMenu}
                        close={() => setToggleMenu(false)}
                    />
                    {children}
                </div>
            </PerfectScrollbar>
        </div>
    ) : (
        <div className="LayoutContainerInfinite">
            <MainHeader
                {...mainHeaderSettings}
                toggleMenu={() => setToggleMenu(!toggleMenu)}
            />
            <Menu open={toggleMenu} close={() => setToggleMenu(false)} />
            {children}
        </div>
    );
};

export default Layout;
